'use strict';

import hero2018 from './hero-2018';

const gdpr = {
  gdprPage: null,
  gdprHeader: null,

  init: function () {
    this.gdprPage = document.querySelectorAll('.js-gdpr');

    if (this.gdprPage.length < 1) {
      return;
    }

    this.gdprHeader = this.gdprPage[0].querySelectorAll('.js-gdpr__header');

    if (this.gdprHeader.length > 0) {
      hero2018.setBodyClasses('light');
    }

    // check for redirect, NHTCONT-680
    const hash = window.location.hash.replace('#', '');
    const redirects = window.gdprRedirects || {};

    if (hash && redirects[hash]) {
      console.log('redirecting to', redirects[hash]);
      window.location.href = redirects[hash];
    }
  },
};

export default gdpr;
